import React from 'react';
import styles from './SocialBar.module.scss';

const socials = [
	{ platform: 'email', icon: 'fas fa-envelope', url: 'https://vuppetmaster.de/kontakt/' },
	{ platform: 'facebook', icon: 'fab fa-facebook', url: 'https://www.facebook.com/VuppetMaster' },
	{ platform: 'twitter', icon: 'fab fa-twitter', url: 'https://twitter.com/VuppetMaster' },
	{ platform: 'linkedin', icon: 'fab fa-linkedin', url: 'https://www.linkedin.com/company/charamel-gmbh/' },
	{ platform: 'instagram', icon: 'fab fa-instagram', url: 'https://www.instagram.com/vuppetmaster/' },
	{ platform: 'youtube', icon: 'fab fa-youtube', url: 'https://www.youtube.com/channel/UCfkp1iecc6BL5HZRAqVYoxw/' },
];

const SocialBar = (props) => (
	<ul className={styles.host}>
		{
			socials.map(entry =>
				<li key={entry.platform} className={styles[entry.platform]}>
					<a href={entry.url} target="_blank" rel="noopener noreferrer">
						<i className={entry.icon}></i>
					</a>
				</li>
			)
		}
	</ul>
);

export default SocialBar;
